// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"108":"45fdfefe7fe8a60c","544":"2e7a83b3e2b5c8c8"}[chunkId] + ".js";
};